/* Skin Radiance listicle page behaviour — idempotent (sections each load this file) */
(function () {
  if (window.__srInit) return;
  window.__srInit = true;

  function init() {
    document.body.classList.add('sr-page');
    var srBlocks = document.querySelectorAll('.sr');
    for (var i = 0; i < srBlocks.length; i++) srBlocks[i].classList.add('sr-js');

    /* reveal on scroll */
    var reveals = document.querySelectorAll('.sr .reveal');
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
        });
      }, { threshold: 0.12 });
      reveals.forEach(function (r) { io.observe(r); });
      setTimeout(function () { reveals.forEach(function (r) { r.classList.add('in'); }); }, 2500);
    } else {
      reveals.forEach(function (r) { r.classList.add('in'); });
    }

    /* sticky buy bar — appears once the hero is scrolled past */
    var sticky = document.getElementById('sr-sticky');
    if (sticky) {
      var onScroll = function () {
        if (window.scrollY > 550) sticky.classList.add('show');
        else sticky.classList.remove('show');
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }

    /* pack-selector modal */
    var modal = document.getElementById('sr-modal');
    function closeModal() {
      if (!modal) return;
      modal.classList.remove('open');
      document.body.style.overflow = '';
    }
    document.addEventListener('click', function (ev) {
      var buy = ev.target.closest('[data-buy]');
      if (buy) {
        ev.preventDefault();
        if (modal) {
          modal.classList.add('open');
          document.body.style.overflow = 'hidden';
        } else {
          var url = buy.getAttribute('data-buy-url');
          if (url) window.location.href = url;
        }
        return;
      }
      if (ev.target.closest('[data-close]')) {
        ev.preventDefault();
        closeModal();
      }
    });
    document.addEventListener('keydown', function (ev) {
      if (ev.key === 'Escape') closeModal();
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
